// subcomponents/income_one/EditModal.js
import {useEffect, useState} from "react";
import {DatePicker, Form, Input, InputNumber, Modal, Select, Typography} from "antd";
import dayjs from "dayjs";

const {Option} = Select;
const {Text} = Typography;

const EditModal = ({visible, record, onClose, onSave}) => {
    const [form] = Form.useForm();
    const [totalWithNds, setTotalWithNds] = useState(0);

    useEffect(() => {
        if (visible) {
            if (record) {
                form.setFieldsValue({
                    name: record.name,
                    type: record.type,
                    cost: record.cost,
                    nds: record.nds,
                    date: record.date ? dayjs(record.date * 1000) : dayjs(),
                });
                calculateTotalWithNds(record.cost, record.nds);
            } else {
                form.resetFields();
                form.setFieldsValue({
                    type: 1,
                    nds: 0,
                    date: dayjs(),
                    cost: 0,
                });
                calculateTotalWithNds(0, 0);
            }
        }
    }, [visible, record, form]);

    const calculateTotalWithNds = (cost, nds) => {
        const numCost = parseFloat(cost) || 0;
        const numNds = parseInt(nds) || 0;

        if (numNds === 0) {
            setTotalWithNds(numCost);
        } else {
            setTotalWithNds(numCost * (1 + numNds / 100));
        }
    };

    const handleValuesChange = (changedValues, allValues) => {
        if (changedValues.cost !== undefined || changedValues.nds !== undefined) {
            calculateTotalWithNds(allValues.cost, allValues.nds);
        }
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();

            const formData = {
                ...values,
                date: values.date ? Math.floor(values.date.valueOf() / 1000) : Math.floor(Date.now() / 1000),
            };

            if (record) {
                formData.id = record.id;
            }

            onSave(formData);
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    return (
        <Modal
            title={record ? "Редактирование дохода" : "Добавление дохода"}
            open={visible}
            onOk={handleOk}
            onCancel={onClose}
            width={600}
            okText="Сохранить"
            cancelText="Отмена"
        >
            <Form
                form={form}
                layout="vertical"
                onValuesChange={handleValuesChange}
            >
                <Form.Item
                    name="name"
                    label="Наименование"
                    rules={[{required: true, message: 'Введите наименование'}]}
                >
                    <Input placeholder="Наименование дохода"/>
                </Form.Item>

                <Form.Item
                    name="date"
                    label="Дата"
                    rules={[{required: true, message: 'Выберите дату'}]}
                >
                    <DatePicker
                        style={{width: '100%'}}
                        format="YYYY-MM-DD"
                        placeholder="Выберите дату"
                    />
                </Form.Item>

                <Form.Item
                    name="type"
                    label="Тип платежа"
                    rules={[{required: true, message: 'Выберите тип платежа'}]}
                >
                    <Select placeholder="Выберите тип">
                        <Option value={1}>Наличная</Option>
                        <Option value={2}>Безналичная</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="cost"
                    label="Сумма без НДС"
                    rules={[{required: true, message: 'Введите сумму'}]}
                >
                    <InputNumber
                        style={{width: '100%'}}
                        min={0}
                        step={0.01}
                        precision={2}
                        placeholder="0.00"
                        addonAfter="€"
                    />
                </Form.Item>

                <Form.Item
                    name="nds"
                    label="НДС"
                    rules={[{required: true, message: 'Выберите НДС'}]}
                >
                    <Select
                        placeholder="Выберите НДС"
                        onChange={(value) => {
                            const cost = form.getFieldValue('cost') || 0;
                            calculateTotalWithNds(cost, value);
                        }}
                    >
                        <Option value={0}>Без НДС (0%)</Option>
                        <Option value={21}>НДС 21%</Option>
                    </Select>
                </Form.Item>

                <div style={{
                    marginTop: 16,
                    padding: 16,
                    background: '#f5f5f5',
                    borderRadius: 4,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Text strong>Итого с НДС:</Text>
                    <Text strong style={{fontSize: 18, color: '#1890ff'}}>
                        {totalWithNds.toFixed(2)} €
                    </Text>
                </div>
            </Form>
        </Modal>
    );
};

export default EditModal;